import { useEffect, useState } from "react";

interface Props {
  startTime: Date;
}

export function LabSessionTimer({ startTime }: Props) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startTime.getTime()) / 1000));
    }, 1000);
    return () => clearInterval(id);
  }, [startTime]);

  const h = Math.floor(elapsed / 3600);
  const m = Math.floor((elapsed % 3600) / 60);
  const s = elapsed % 60;

  const pad = (n: number) => String(n).padStart(2, "0");

  return (
    <span className="font-mono text-sm tabular-nums text-amber-700 dark:text-amber-400">
      {h > 0 ? `${pad(h)}:` : ""}{pad(m)}:{pad(s)}
    </span>
  );
}
